// noinspection ES6CheckImport

import React from 'react';
import { bindActionCreators } from 'redux';
import { BrowserRouter as Router } from 'react-router-dom';
import DateFnsUtils from '@date-io/date-fns';
import { ru } from 'date-fns/locale';
import { SnackbarProvider } from 'notistack';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { connect } from 'react-redux';
import Login from '@/modules/login/components/Login';
import Websocket from '@/modules/common/components/Websocket';
import { actionSetTypes } from '@/modules/application/actions/types';
import { actionSetStatuses } from '@/modules/application/actions/statuses';
import { actionSetCfgOffers } from '@/modules/application/actions/cfg';
import { actionSetAffiliates } from '@/modules/application/actions/affiliates';
import Dock from './Dock/Dock';
import AppBar from './AppBar';
import Switch from './Switch';
import '../styles/Application.scss';

const Application = (props) => {
    return (
        <SnackbarProvider classes={{
                              containerRoot: 'snackbar-container',
                              variantSuccess: 'snackbar-success',
                              variantError: 'snackbar-error',
                          }}
                          anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                          hideIconVariant={true} maxSnack={5}
        >
            {(props.user)
                ? <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ru}><Router>
                    <Dock/>
                    <AppBar/>
                    <main>
                        <Switch/>
                    </main>
                    <Websocket path='/ws/types/' onMessage={(data) => props.setTypes(JSON.parse(data))}/>
                    <Websocket path='/ws/cfg/offers/' onMessage={(data) => props.setCfgOffers(JSON.parse(data))}/>
                    {(!props.user.affiliate)
                        ? <>
                            <Websocket path='/ws/statuses/' onMessage={(data) => props.setStatuses(JSON.parse(data))}/>
                            <Websocket path='/ws/affiliates/'
                                       onMessage={(data) => props.setAffiliates(JSON.parse(data))}
                            />
                        </>
                        : null
                    }
                </Router></MuiPickersUtilsProvider>
                : <Login/>
            }
        </SnackbarProvider>
    );
};

export default connect(
    (state) => ({
        user: state.auth.user,
    }),
    (dispatch) => ({
        setTypes: bindActionCreators(actionSetTypes, dispatch),
        setCfgOffers: bindActionCreators(actionSetCfgOffers, dispatch),
        setStatuses: bindActionCreators(actionSetStatuses, dispatch),
        setAffiliates: bindActionCreators(actionSetAffiliates, dispatch),
    })
)(Application);
